import { render, staticRenderFns } from "./IconButtonArrowDownGrey.vue?vue&type=template&id=9b38789e"
import script from "./IconButtonArrowDownGrey.vue?vue&type=script&lang=js"
export * from "./IconButtonArrowDownGrey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports